import { render, staticRenderFns } from "./FrontJacketCreate.vue?vue&type=template&id=71352095&scoped=true&"
import script from "./FrontJacketCreate.vue?vue&type=script&lang=js&"
export * from "./FrontJacketCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71352095",
  null
  
)

export default component.exports